import {BrowserModule} from '@angular/platform-browser';
import {NgModule, LOCALE_ID} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AppComponent} from './app.component';
import {HeaderComponent} from './shared/header/header.component';
import {FooterComponent} from './shared/footer/footer.component';
import {HomeLoginComponent} from './pages/home-login/home.component';
import {HomeComponent} from './pages/home/home.component';
import {TariffChoose} from './pages/TariffChoose/TariffChoose';

import {Step1Component} from './pages/LoginUP/step1.component';
import {IboxComponent} from './pages/IBox/IBox.component';
import {LogACodComponent} from './pages/LoginACod/LogACod.component';

import {ToasterModule, ToasterService} from 'angular5-toaster/dist';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {HttpInterceptorService} from './services/http-interceptor.service';
import {HttpRequestService} from './services/http-request.service';
import {ClickOutsideDirective} from './directives/click-outside.directive';
import {WebShopApiService} from './services/web-shop-api.service';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {EditComponent} from './pages/edit/edit.component';

import {registerLocaleData} from '@angular/common';
import localeSrb from '@angular/common/locales/sr-Latn';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {StorageHelperService} from './services/storage-helper.service';
import {AuthGuardStep3, AuthGuardStep4, AuthGuardSuccess} from './services/auth.guard';
import { RedirectPageComponent } from './pages/redirect-page/redirect-page.component';
import {SharedService} from './services/shared.service';
import {HttpModule} from '@angular/http';
import {CalcApiService} from './services/calc-api.service';

import {TokenManager} from './services/TokenManager';



import { TarrifCalcFamilyPartnerComponent } from './pages/tarrif-calc-family-partner/tarrif-calc-family-partner.component';
import { TarrifKComponent } from './pages/tarrif-k/tarrif-k.component';
import { TarrifCalcFondComponent } from './pages/tarrif-calc-fond/tarrif-calc-fond.component';
import { TarrifCalcKolektivComponent } from './pages/TarrifCalcKolektiv/TarrifCalc.component';
import { TarrifCalcFondJuniorComponent } from './pages/tarrif-calc-fond-junior/tarrif-calc-fond-junior.component';
import { TarrifCalcComponent } from './pages/TarrifCalc/TarrifCalc.component';
import { TarrifCalcEliteComponent } from './pages/TarrifCalcElite/TarrifCalc.component';
import { TarrifCalcHorizontComponent } from './pages/TarrifCalcHorizont/TarrifCalc.component';
import { TarrifCalcJednokratnoComponent } from './pages/TarrifCalcJednokratno/TarrifCalc.component';
import { TarrifCalcKidsComponent } from './pages/TarrifCalcKids/TarrifCalc.component';
import { TarrifCalcPremiumComponent } from './pages/TarrifCalcPremium/TarrifCalc.component';
import { TarrifCalcR1Component } from './pages/TarrifCalcR1/TarrifCalc.component';
import { TarrifCalcRK11Component } from './pages/TarrifCalcRK11/TarrifCalc.component';
import { TarrifCalcRK5Component } from './pages/TarrifCalcRK5/TarrifCalc.component';
import { TarrifCalcSmartComponent } from './pages/TarrifCalcSmart/TarrifCalc.component';
import { TarrifCalcFondJuniorplusComponent } from './pages/tarrif-calc-fond-juniorplus/tarrif-calc-fond-juniorplus.component';
import { TarrifCalcSafeLifeGlobalComponent } from './pages/tarrif-calc-safe-life-global/tarrif-calc-safe-life-global.component';

registerLocaleData(localeSrb, 'sr-Latn');

const appRoutes: Routes = [

  {path: 'TariffCalc', component: TarrifCalcComponent},
  {path: 'TariffCalcElite', component: TarrifCalcEliteComponent},
  {path: 'TariffCalcSmart', component: TarrifCalcSmartComponent},
  {path: 'TariffCalcKids', component: TarrifCalcKidsComponent},
  {path: 'TariffCalcJednokratno', component: TarrifCalcJednokratnoComponent},
  {path: 'TariffCalcR1', component: TarrifCalcR1Component},
  {path: 'TariffCalcKolektiv', component: TarrifCalcKolektivComponent},
  {path: 'TariffCalcRK5', component: TarrifCalcRK5Component},
  {path: 'TariffCalcRK11', component: TarrifCalcRK11Component},
  {path: 'TariffCalcHorizont', component: TarrifCalcHorizontComponent},
  {path: 'TariffCalcK', component: TarrifKComponent},
  {path: 'TariffCalcPremium', component: TarrifCalcPremiumComponent},
  {path: 'TariffCalcFamilyPartner', component: TarrifCalcFamilyPartnerComponent},
  {path: 'TarrifCalcFondComponent', component: TarrifCalcFondComponent},
  {path: 'TarrifCalcSafeLifeGlobalComponent', component: TarrifCalcSafeLifeGlobalComponent},  
  {path: 'TarrifCalcFondJuniorComponent', component: TarrifCalcFondJuniorComponent},
  {path: 'TarrifCalcFondJuniorplusComponent', component: TarrifCalcFondJuniorplusComponent},
  {path: 'TarrifChoos', component: TariffChoose},
  {path: 'ibox', component: IboxComponent},
  {path: 'homemenu', component: HomeComponent},
   {path: 'LogACod', component: LogACodComponent},
  {path: 'home', component: Step1Component},

  // {path: 'edit', component: EditComponent},
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: '**', redirectTo: '/home', pathMatch: 'full'}
];

@NgModule({
  declarations: [
    AppComponent,
    TariffChoose,
    HeaderComponent,
    FooterComponent,
    TarrifCalcComponent,
    TarrifCalcEliteComponent,
    TarrifCalcPremiumComponent,
    TarrifCalcKolektivComponent,
    TarrifCalcSmartComponent,
    TarrifCalcKidsComponent,
    TarrifCalcJednokratnoComponent,
    TarrifCalcR1Component,
    TarrifCalcRK5Component,
    TarrifCalcRK11Component,
    TarrifCalcHorizontComponent,
    HomeComponent,
    IboxComponent,
    LogACodComponent,
    HomeLoginComponent,
    Step1Component,
    ClickOutsideDirective,
    EditComponent,
    RedirectPageComponent,
    TarrifCalcFamilyPartnerComponent,
    TarrifKComponent,
    TarrifCalcFondComponent,
    TarrifCalcSafeLifeGlobalComponent,
    TarrifCalcFondJuniorComponent ,
    TarrifCalcFondJuniorplusComponent,
    TarrifCalcSafeLifeGlobalComponent 
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    ToasterModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule
  ],
  providers: [ToasterService, {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpInterceptorService,
    multi: true,
  }, HttpRequestService, WebShopApiService,
     {provide: LOCALE_ID, useValue: 'sr-Latn'},
    StorageHelperService,
    AuthGuardStep3, AuthGuardStep4, CalcApiService, TokenManager, AuthGuardSuccess, SharedService],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts